import { NgModule } from '@angular/core';
import { CmsConfig, provideConfigFactory } from '@spartacus/core';
import { UserAccountEventModule } from './events';
import {
  USER_ACCOUNT_CORE_FEATURE,
  USER_ACCOUNT_FEATURE
} from './feature-name';

// TODO: Inline this factory when we start releasing Ivy compiled libraries
export function defaultUserAccountComponentsConfig(): CmsConfig {
  const config: CmsConfig = {
    featureModules: {
      [USER_ACCOUNT_FEATURE]: {
        cmsComponents: [
          'KnBrSellerApproverMessageComponent',
          'KnBrLoginFormComponent',
          'RegisterCustomerComponent',
        ],
      },
      [USER_ACCOUNT_CORE_FEATURE]: USER_ACCOUNT_FEATURE,
    },
  };
  return config;
}

@NgModule({
  imports: [UserAccountEventModule],
  providers: [provideConfigFactory(defaultUserAccountComponentsConfig)],
})
export class UserAccountRootModule { }
